import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
// Models
import {
	ProductsModel,
	AutoCompleteScopeOrder,
	SubProduct,
	SubProductInfo
} from '../model/product.model';
import {
	MSG_FIELDS_OPTIONS,
	MSG_FIELDS_VALUE,
	INTEGRATIONS,
	SIDE_CAR_ORIGINS
} from '../model/product-constant';
import { PRODUCT_FORM_CONFIG } from '../model/product-form-config.model';
import { IdNameObjectType } from '../../state/models/global-configuration-state.model';
import { AssetOnCompletionModel } from '../../components/messages/model/data-message.model';

import { ObjectUtils, ToasterType } from '@cv-invision/core';
import { GlobalConfigurationState } from '../../state/global-configuration.state';

// services
import { GenericIntegrationService } from '../../service/generic-integration.service';
import { GenericFormService, GenericFormHelper } from '@cv-invision/cv.invision-views.ux';
import { ProductsService } from '../service/products.service';
import { BroadcastService } from '@cv-invision/core';
import { GlobalConfigurationEnumsState } from "../../state/global-configuration-enums.state";

@Component({
	selector: 'cv-invision-create-update-products',
	templateUrl: './create-update-products.component.html',
	styleUrls: ['./create-update-products.component.scss'],
	providers: [GenericFormService]
})
export class CreateUpdateProductsComponent implements OnInit, OnDestroy, AfterViewChecked {
	appScopeProductList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getAppScopeProducts);
	acuityProductList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getAcuityProducts);
	cmpAcuityProductList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getCmpAcuityProducts);

	nexsysProductList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getNexsysProducts);
	valutrustProductList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getValuTrustProducts);
	xpanseProductList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getXpanseProducts);
	fncProductList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getFNCProducts);
	genericIntegrationList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getGenericIntegrationsIdNameObjectType);

	insideMapsProductList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getInsideMapsProducts);
	nexsysAttributesList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getNexsysAttributeList);
	assetsOnCompletionAppscope: Array<AssetOnCompletionModel> = this.store.selectSnapshot(GlobalConfigurationState.getAssetsOnCompletionAppscope);
	assetsOnCompletionAcuity: Array<AssetOnCompletionModel> = this.store.selectSnapshot(GlobalConfigurationState.getAssetsOnCompletionAcuity);
	milestoneAcuityList = this.store.selectSnapshot(GlobalConfigurationState.getAcuityMilestones);
	cmpMilestoneAcuityList = this.store.selectSnapshot(GlobalConfigurationState.getCmpAcuityMilestones);
	schemasList = this.store.selectSnapshot(GlobalConfigurationState.getSchemaList);
	originList = this.store.selectSnapshot(GlobalConfigurationEnumsState.getOrigins);
	productTypeList = this.store.selectSnapshot(GlobalConfigurationEnumsState.getProductTypes);
	inspectionTypeList = this.store.selectSnapshot(GlobalConfigurationEnumsState.getInspectionTypes);

	extraData = {
		'appscope': this.store.selectSnapshot(GlobalConfigurationState.getAppScopeDocumentTypes),
		'acuity': this.store.selectSnapshot(GlobalConfigurationState.getAcuityDocumentTypes),
		'class': this.store.selectSnapshot(GlobalConfigurationState.getClassValuationDocTypes),
		'cmpacuity': this.store.selectSnapshot(GlobalConfigurationState.getCmpAcuityDocumentTypes),
		'integrationProductList': []
	}

	viewMode: boolean;
	private atComponentDestroy = new Subject();
	productData: ProductsModel = new ProductsModel();
	saving: boolean;
	isEdit: boolean;

	errorMessages: Array<any> = [];
	enableAcuityMsg: string;
	enableAppScopeMsg: string;
	productId: string = this.activateRoute.snapshot.paramMap.get('prodId');
	public title: string;

	formIsReady: boolean;
	public productFormConfig = {};
	public integrations = INTEGRATIONS;

	get originSelected(): string {
		return this.genericFormService.form?.get('origin').value || null;
	}

	get appScopeEnabled(): boolean {
		return this.genericFormService.form?.get('appScope.enabled').value || null;
	}

	get canSetIntegration(): boolean {
		return this.genericFormService.form?.get('origin').value === MSG_FIELDS_OPTIONS.CLASSVALUATION;
	}

	get canSetSideCar(): boolean {
		const indexOriginSelected = SIDE_CAR_ORIGINS.findIndex(element => element.id === this.originSelected)
		return (indexOriginSelected >= 0 && this.genericFormService.form.get('acuity.enabled')?.value) || false;
	}

	get licensingServiceEnabled(): boolean {
		return this.genericFormService.form?.get('licensingServiceSetting.enabled')?.value || false;
	}

	get integrationSelected(): string {
		const element = Object.entries(this.genericFormService.form?.value)
			.filter(([key, value]) => (
				INTEGRATIONS.includes(key) && value['enabled']))

		return element.length > 0 ? (element[0][0]) : null;
	}

	get genericIntegrationSelected(): string {
		const integrationIdOptions = this.genericFormService.formFieldList['integration']['integrationId']?.options
		const indexOption = integrationIdOptions.findIndex(element => element.value === this.genericFormService.form?.get('integration.integrationId')?.value);
		if (indexOption >= 0) {
			return integrationIdOptions[indexOption].label;
		}
		return null;
	}

	get integrationEnabled(): boolean {
		return this.genericFormService.form?.get('nexsys.enabled').value ||
			this.genericFormService.form?.get('valutrust.enabled').value ||
			this.genericFormService.form?.get('xpanse.enabled').value ||
			this.genericFormService.form?.get('integration.enabled').value;
	}

	get isFormValid(): boolean {
		return this.genericFormService.form?.valid;
	}

	constructor(
		private store: Store,
		private productService: ProductsService,
		private genericIntegrationService: GenericIntegrationService,
		private broadcastService: BroadcastService,
		private activateRoute: ActivatedRoute,
		private router: Router,
		private genericFormService: GenericFormService,
		private cdRef: ChangeDetectorRef
	) {

		this.saving = false;
		this.viewMode = false;
		this.isEdit = false;
		this.formIsReady = false;

	}

	ngAfterViewChecked() {
		this.cdRef.detectChanges();
	}

	ngOnInit(): void {
		this.formIsReady = false;
		if (this.productId) {
			this.isEdit = true;
			this.title = 'Edit Product Configuration';
		} else {
			this.title = 'Create Product Configuration';
		}

		this.productFormConfig = ObjectUtils.recursiveDeepCopy(PRODUCT_FORM_CONFIG);
		this.productData = new ProductsModel();
		this.setModelOptions();

		if (this.viewMode) {
			this.enableViewMode(this.productFormConfig);
		}
		this.genericFormService.setFormFieldList(ObjectUtils.recursiveDeepCopy(this.productFormConfig));

		this.genericFormService.formObserver
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((data) => {
				if (data) {
					this.formIsReady = true;
					this.formEvents();
				}
			});

		this.genericFormService.onChangeOptions$
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((data: any) => {
				const field = data.field;
				const fieldOptions = data.fieldOptions;

				switch (fieldOptions.path) {
					case 'origin':
						this.onOriginSelected({id: data.event.value});
						break;
					case 'acuity.instance':
						this.setAcuityOptionsList(data.event.value);
						break;
					case 'acuity.enabled':
						// eslint-disable-next-line no-case-declarations
						const origin = this.genericFormService.form.get('origin').value;
						this.setAcuityOptionsList(origin);
						break;
					case 'integration.integrationId':
						this.onGenericIntegrationSelected(data.event.value);
						break;
				}

				if (field.UIEvents.onChange) {
					if (fieldOptions?.path === 'acuity.autoCompleteScopeOrderOption.documents') {
						field.UIEvents.onChange(data.event, this.genericFormService.formFieldList, this.genericFormService.form, this.extraData, fieldOptions);
					} else {
						field.UIEvents.onChange(data.event, this.genericFormService.formFieldList, this.genericFormService.form, field);
					}
				}
			});

		if (this.productId) {
			this.createForm();
		} else {
			this.genericFormService.setV2(true);
			this.genericFormService.initForm(this.productData);
			this.handleFieldMsg('');
		}
	}

	enableViewMode(formFieldList) {
		for (const key in formFieldList) {
			if ('DataType' in formFieldList[key]) {
				formFieldList[key].disabled = true;
				if (formFieldList[key].DataType === 'Array') {
					this.enableViewMode(formFieldList[key].child);
				}

			} else {
				this.enableViewMode(formFieldList[key]);
			}
		}
	}

	/**
	 * event to call API and create formData in product page
	 */
	public createForm() {
		this.productService
			.getProductListById(this.productId)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((response) => {
				this.productData = response;

				if (!this.productData.acuity.autoCompleteScopeOrderOption) {
					this.productData.acuity.autoCompleteScopeOrderOption = new AutoCompleteScopeOrder();
				}

				const subproductConfiguration = new SubProduct();

				if (this.productData.subProductConfiguration?.products === null || this.productData.subProductConfiguration?.products === null) {
					this.productData.subProductConfiguration.products = [
						new SubProductInfo(),
						new SubProductInfo()
					]
				} else if (this.productData.subProductConfiguration?.products?.length === 0) {
					this.productData.subProductConfiguration.products = ObjectUtils.recursiveDeepCopy(subproductConfiguration.products);
				} else {
					const products = ObjectUtils.recursiveDeepCopy(subproductConfiguration.products);
					products[0] = response.subProductConfiguration.products[0];
					products[1] = response.subProductConfiguration.products[1] || new SubProductInfo();
					this.productData.subProductConfiguration.products = products;
				}

				this.onOriginSelected({id: this.productData.origin});

				this.genericFormService.formFieldList['acuity']['autoCompleteScopeOrderOption']['uploadDocuments'].DisplayText = `Upload documents inside ${this.productData.origin === 'CMPAcuity' ? 'CMPAcuity (SIDECAR 1)' : this.productData.origin || 'Appscope'} when milestone is:`;

				this.genericFormService.setV2(true);
				this.genericFormService.initForm(this.productData);
			});
	}

	/**
	 * event to fill options in generic form dropdown on edit mode
	 */
	formEvents(): void {
		this.setAcuityOptionsList(this.productData.acuity.instance);
		this.onGenericIntegrationSelected(this.productData.integration.integrationId);
	}

	/**
	 * event to set options from state to genericformbuilder configuration
	 */
	setModelOptions(): void {
		this.appScopeProductList = this.appScopeProductList.map(
			(appScopeProduct) => {
				return {
					value: appScopeProduct.id,
					label: '(' + appScopeProduct.id + ') ' + appScopeProduct.title,
				};
			}
		);
		this.productFormConfig['origin'].options = GenericFormHelper.getDropdownValues(this.originList, 'name', 'id');
		this.productFormConfig['productType'].options = GenericFormHelper.getDropdownValues(this.productTypeList, 'name', 'id');
		this.productFormConfig['valuationType'].options = GenericFormHelper.getDropdownValues(this.inspectionTypeList, 'name', 'id');
		this.productFormConfig['appScope']['jobId'].options = this.appScopeProductList;
		this.productFormConfig['integration']['integrationId'].options = GenericFormHelper.getDropdownValues(this.genericIntegrationList, 'name', 'id');
		this.productFormConfig['appScope']['productAssetsId'].options = GenericFormHelper.getDropdownValues(this.assetsOnCompletionAppscope, 'description', 'id');
		this.productFormConfig['acuity']['productAssetsId'].options = GenericFormHelper.getDropdownValues(this.assetsOnCompletionAcuity, 'description', 'id');
		this.productFormConfig['inspection']['schema'].options = GenericFormHelper.getDropdownValues(this.schemasList, 'name', 'name');
		this.productFormConfig['insideMaps']['insideMapsId'].options = GenericFormHelper.getDropdownValues(this.insideMapsProductList, 'title', 'id');

		this.productFormConfig['nexsys']['orderAttribute'].options = GenericFormHelper.getDropdownValues(this.nexsysAttributesList, 'title', 'id');
		this.productFormConfig['nexsys']['productId'].options = GenericFormHelper.getDropdownValues(this.nexsysProductList, 'title', 'id');
		this.productFormConfig['valutrust']['productId'].options = GenericFormHelper.getDropdownValues(this.valutrustProductList, 'title', 'id')
		this.productFormConfig['xpanse']['productId'].options = GenericFormHelper.getDropdownValues(this.xpanseProductList, 'title', 'id')
		this.productFormConfig['fnc']['productId'].options = GenericFormHelper.getDropdownValues(this.fncProductList, 'title', 'id')

		const productList = GenericFormHelper.getDropdownValues(this.acuityProductList, 'title', 'id');
		const milestoneAcuityList = GenericFormHelper.getDropdownValues(this.milestoneAcuityList, 'title', 'id');

		this.productFormConfig['acuity']['productId'].options = productList;
		this.productFormConfig['licensingServiceSetting']['acuityCreationSetting']['acuityProductId'].options = productList;
		this.productFormConfig['acuity']['autoCompleteScopeOrderOption']['autoCompleteMilestoneTrigger'].options = milestoneAcuityList;
		this.productFormConfig['acuity']['autoCompleteScopeOrderOption']['uploadDocumentsMilestone'].options = milestoneAcuityList;
		this.productFormConfig['acuity']['bpoLinkTrigger'].options = milestoneAcuityList;
		this.productFormConfig['acuity']['autoCompleteScopeOrderOption']['documents'].extraData = this.extraData;

		this.productFormConfig['appScope']['creationStatusTrigger'].options = milestoneAcuityList;
		this.productFormConfig['subProductConfiguration']['products'].child[0]['creationStatusTrigger'].options = milestoneAcuityList;


		this.productService.getOptionsSoftwareColector()
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((result) => {
				this.genericFormService.formFieldList['inspection']['softwareCollector'].options = result.data.map((item: IdNameObjectType) => {
					return {
						label: item,
						value: item,
					};
				});
			});
	}

	/**
	 * On Save button.
	 */
	onSave(): void {
		this.saving = true;
		this.errorMessages = [];
		const productData = this.genericFormService.form?.getRawValue();
		const subProductConfig = ObjectUtils.recursiveDeepCopy(productData.subProductConfiguration.products);
		productData.subProductConfiguration.products = [];

		if (subProductConfig[0]?.id) {
			productData.subProductConfiguration.products.push(subProductConfig[0])
		}

		if (subProductConfig[1]?.id) {
			delete subProductConfig[1].creationStatusTrigger;
			delete subProductConfig[1].creationTrigger;
			productData.subProductConfiguration.products.push(subProductConfig[1])
		}

		if (this.productId) {
			this.productService
				.updateProduct(this.productId, productData)
				.pipe(takeUntil(this.atComponentDestroy))
				.subscribe(
					(response) => {
						if (response.succeeded) {
							this.successHandleFunction();
						}
					},
					(error) => {
						this.errorMessages = error.error.error.split(',');
						this.saving = false;
					}
				);
		} else {
			this.productService.setNewProduct(productData)
				.pipe(takeUntil(this.atComponentDestroy))
				.subscribe(
					(response) => {
						if (response.succeeded) {
							this.successHandleFunction();
						}
					},
					(error) => {
						this.errorMessages = error.error.error.split(',');
						this.saving = false;
					}
				);
		}
	}

	/**
	 * On generic integration selected
	 * @param $event
	 */
	onGenericIntegrationSelected(genericIntegrationId: string): void {
		this.genericFormService.formFieldList['integration']['productId'].options = [];

		if (genericIntegrationId) {
			this.genericIntegrationService.getIntegrationProducts(genericIntegrationId)
				.pipe(takeUntil(this.atComponentDestroy))
				.subscribe((result) => {
					if (result) {
						this.genericFormService.formFieldList['integration']['productId'].options = GenericFormHelper.getDropdownValues(result, 'label', 'key');
					}
				});
		}
	}

	/**
	 * select origin source irder
	 * @param $event
	 */
	onOriginSelected($event: any): void {
		this.productData.origin = $event ? $event.id : null;
		this.getSubProductByOrigin($event?.id);
		if (!$event) {
			this.handleFieldMsg('');
			return;
		}
		this.handleFieldMsg($event.id);
	}

	/**
	 * get subproduct by origin
	 * @param origin
	 */
	getSubProductByOrigin(origin: string): void {
		let subProductList = [];

		if (!origin || origin === 'Acuity') {
			return;
		}

		this.productService.getProductListByOrigin(origin)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((result) => {

				subProductList = GenericFormHelper.getDropdownValues(result.data, 'title', 'id');
				this.genericFormService.formFieldList['subProductConfiguration']['products'].child[0]['id'].options = subProductList;
				this.genericFormService.formFieldList['subProductConfiguration']['products'].child[1]['id'].options = subProductList;
				this.genericFormService.formFieldList['licensingServiceSetting']['subProductConfiguration']['products'].child[0]['id'].options = subProductList;
				this.genericFormService.formFieldList['licensingServiceSetting']['subProductConfiguration']['products'].child[1]['id'].options = subProductList;
			});
	}

	/***
	 * set msg field depend on selected option
	 */
	handleFieldMsg(type: string): void {
		switch (type) {
			case MSG_FIELDS_OPTIONS.ACUITY:
			case MSG_FIELDS_OPTIONS.CMPACUITY:
				this.enableAcuityMsg = MSG_FIELDS_VALUE.ACUITYCHECK.ACUITY;
				this.enableAppScopeMsg = MSG_FIELDS_VALUE.ACUITYCHECK.SCOPE;
				break;
			case MSG_FIELDS_OPTIONS.CLASSORDERENTRY:
			case MSG_FIELDS_OPTIONS.APPSCOPE:
				this.enableAcuityMsg = MSG_FIELDS_VALUE.APPSCOPECHECK.ACUITY;
				this.enableAppScopeMsg = MSG_FIELDS_VALUE.APPSCOPECHECK.SCOPE;
				break;
			case MSG_FIELDS_OPTIONS.CLASSVALUATION:
				this.enableAcuityMsg = MSG_FIELDS_VALUE.DEFAULT.ACUITY;
				this.enableAppScopeMsg = MSG_FIELDS_VALUE.DEFAULT.SCOPE;
				break;
		}
	}

	/**
	 * handle response from server
	 */
	successHandleFunction(): void {
		const msgSuget = this.productId ? 'Updated' : 'Created';
		const msg = `The Product was ${msgSuget} successfully`;
		this.broadcastService.broadcast({
			name: ToasterType.SUCCESS,
			event: {message: msg},
		});

		this.router.navigate([`/global-configuration/product/product-list`]);
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}

	/**
	 * Event to set products & milestones list from acuity or cmp acuity
	 * @param origin
	 */
	setAcuityOptionsList(origin: string): void {
		let acuityProductList = [];
		let milestoneAcuityList = [];

		if (origin === 'cmpacuity') {
			acuityProductList = this.cmpAcuityProductList;
			milestoneAcuityList = this.cmpMilestoneAcuityList;
		} else if (origin === 'acuity') {
			acuityProductList = this.acuityProductList;
			milestoneAcuityList = this.milestoneAcuityList;
		}

		const productList = GenericFormHelper.getDropdownValues(acuityProductList, 'title', 'id');
		const milestoneAcuityListMapped = GenericFormHelper.getDropdownValues(milestoneAcuityList, 'title', 'id');

		this.genericFormService.formFieldList['acuity']['productId'].options = ObjectUtils.recursiveDeepCopy(productList);
		this.genericFormService.formFieldList['licensingServiceSetting']['acuityCreationSetting']['acuityProductId'].options = ObjectUtils.recursiveDeepCopy(productList);
		this.genericFormService.formFieldList['acuity']['autoCompleteScopeOrderOption']['autoCompleteMilestoneTrigger'].options = ObjectUtils.recursiveDeepCopy(milestoneAcuityListMapped);
		this.genericFormService.formFieldList['acuity']['autoCompleteScopeOrderOption']['uploadDocumentsMilestone'].options = ObjectUtils.recursiveDeepCopy(milestoneAcuityListMapped);
		this.genericFormService.formFieldList['acuity']['bpoLinkTrigger'].options = ObjectUtils.recursiveDeepCopy(milestoneAcuityListMapped);
		this.genericFormService.formFieldList['appScope']['creationStatusTrigger'].options = ObjectUtils.recursiveDeepCopy(milestoneAcuityListMapped);
		this.genericFormService.formFieldList['subProductConfiguration']['products'].child[0]['creationStatusTrigger'].options = ObjectUtils.recursiveDeepCopy(milestoneAcuityListMapped);
	}
}
